import "../../styles/all.css"
import "./start.css"
import hero from "../../img/hero-img.png"
import { useTranslation } from "react-i18next";

function Start(){
          const { t } = useTranslation();

    return(
        <>
        <div className="start" data-aos="zoom-in-down">
            <div className="text">
                <h1>{t("textone")}</h1>
                <h1>{t("texttwo")}</h1>
                <h1>{t("textthree")}</h1>
                <button>{t("buttonone")}</button>
                <button>{t("buttontwo")}</button>

            </div>
            <div className="image">
                <img src={hero} alt="" />
            </div>
        </div>
        </>
    )
}
export default  Start